// src/mixins/zoom.mixin.js
import { useZoomStore } from '@/stores/zoom';

export default {
  data() {
    return {
      zoomLevel: 100,     // legacy field kept for compatibility
      _zoomSyncing: false, // guard to avoid watch loops
      _unsubZoom: null,    // store subscription cleanup
    };
  },

  computed: {
    // keep your legacy computed props working
    rowHeight() {
      const multiplier = 1 - this.zoomLevel / 100 + 1;
      return 360 * (multiplier * 1.35);
    },
    zoomInDisabled() {
      return this.zoomLevel === 150
        ? { '--cursor': 'not-allowed', '--color': '#ffffff80' }
        : { '--cursor': 'pointer', '--color': 'white' };
    },
    zoomOutDisabled() {
      return this.zoomLevel === 25
        ? { '--cursor': 'not-allowed', '--color': '#ffffff80' }
        : { '--cursor': 'pointer', '--color': 'white' };
    },

    // expose the actual store if you ever need it in templates
    zoomStore() {
      return this._zoomStore || (this._zoomStore = useZoomStore());
    },
  },

  created() {
    // initialize store (sets CSS vars, loads persisted value, etc.)
    this.zoomStore.init();

    // sync legacy field with store once at start
    this.zoomLevel = this.zoomStore.level;

    // subscribe to store updates -> reflect into legacy zoomLevel
    this._unsubZoom = this.zoomStore.$subscribe((_mutation, state) => {
      if (this._zoomSyncing) return;
      this._zoomSyncing = true;
      this.zoomLevel = state.level;     // updates legacy consumers
      this.$emit('zoomChange', state.level);
      this._zoomSyncing = false;
    });
  },

  beforeDestroy() {
    if (this._unsubZoom) {
      this._unsubZoom();
      this._unsubZoom = null;
    }
  },

  watch: {
    // legacy entry point: whenever *component code* sets zoomLevel,
    // push it into the store (clamped by store’s set()).
    zoomLevel(newVal) {
      if (this._zoomSyncing) return;
      this._zoomSyncing = true;
      this.zoomStore.set(newVal);
      this.$emit('zoomChange', this.zoomStore.level);
      this._zoomSyncing = false;
    },
  },

  methods: {
    // Keep method names/signatures and delegate to store
    zoomIn()  {
      this.zoomStore.zoomIn();
      // zoomLevel will sync via store subscription
    },
    zoomOut() {
      this.zoomStore.zoomOut();
    },
    resetZoom() {
      this.zoomStore.reset();
    },

    // Your helper that fits content to screen—now just sets via store
    adjustScreen() {
      const container = this.$refs.dashboardArea;
      if (!container) return;
      const pct = (window.innerHeight / container.scrollHeight) * 100;
      this.zoomStore.set(pct);
      // zoomLevel mirrors via subscription/watch
    },
  },
};
